import $ from 'jquery'

class ScrollableTable {
  constructor(el) {
    this.el = el
    this.table = this.el.querySelector('.table')
    this.navItems = this.el.querySelectorAll('.categories li')
    this.offset = this.table.querySelector('li:first-child').offsetWidth
    this.scrollContainer = this.el.querySelector('.scroller')
    this.currentIndex = 0
    this.positions = [
      $('.table li:nth-child(2)').position().left - this.offset - 16,
      $('.table li:nth-child(3)').position().left - this.offset - 16,
      $('.table li:nth-child(4)').position().left - this.offset - 16
    ]

    // console.dir(this.positions)

    // console.log('offset', this.offset)

    this.navItems.forEach((item, index) => {
      item.addEventListener('click', () => {
        if (this.currentIndex === index) return
        this.currentIndex = index
        // console.log($('.table li:nth-child(' + (index + 2) + ')').position().left)
        $( this.scrollContainer).animate({ scrollLeft: this.positions[index] }, { duration: 250, easing: 'linear'})
      })
    })
  }
}
export default ScrollableTable


// WEBPACK FOOTER //
// ./js/classes/scrollable-table.class.js